import { render } from "./mybuyView.vue?vue&type=template&id=22040b44&scoped=true"
import script from "./mybuyView.vue?vue&type=script&lang=js"
export * from "./mybuyView.vue?vue&type=script&lang=js"

import "./mybuyView.vue?vue&type=style&index=0&id=22040b44&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22040b44"]])

export default __exports__